import React from 'react'
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
const CheckoutProductCell = ({itemin, addressValue}) => {
    return (
        <>
            <div className={`${itemin?.deliveryAvailable==0?`d-flex not-deliver-product`:`d-flex`}`}>
                <div className=''><img src={itemin?.image} style={{ width: '50px' }} alt="" /></div>
                <div className='flex-grow-1 ms-2'>
                    <div className='row'>
                        <div className='col-12 fw-bold cartpname'>
                            {itemin?.productName}
                        </div>
                        <div className='col-12 txtlgeay f12'>
                            Dealer: {itemin?.dealerName}
                        </div>
                        {addressValue?<>{itemin?.deliveryAvailable==0?<div className='f12 txtred'>Currently out of stock for this address </div>:<></>}</>:<></>}
                        
                    </div>
                    <div className='row d-flex mt-1 align-items-center'>
                        <div className='f12 col-4 col-md-4'>
                            <CurrencyRupeeIcon className='f12' />{itemin?.price}
                        </div>
                        <div className='d-flex align-items-center f12 col-4 col-md-4'>
                            Qty: {itemin?.qty}
                        </div>
                        <div className='text-start text-md-end col-4 col-md-4'>
                            <div className='f14 fw-bold'><CurrencyRupeeIcon className='f14' />{itemin?.subTotal}</div>
                        </div>
                    </div>
                    {itemin?.offer > 0?<><div className='f12 text-end text-success'>Offer Applied- <CurrencyRupeeIcon className='f14' />{itemin?.offer}</div></>:<><div></div></>}
                </div>
            </div>
            <hr className='m-0 mt-2 mb-2' />
        </>
    )
}

export default CheckoutProductCell